const defaultLocale = 'en';

const context = require.context("./locales", true, /\.json$/);

var locales = {};
context.keys().forEach((key) => {
  locales[key] = true;
})

var cache = {};

function localeSupported(locale) {
  return locales[`./${locale}.json`];
}

function getLocale(locale) {
  if(!cache[locale]) {
    var localeData = context(`./${locale}.json`);
    if(locale != defaultLocale) {
      localeData = addFallbacks(getLocale(defaultLocale), localeData);
    }
    cache[locale] = localeData;
  }
  return cache[locale];
}

function addFallbacks(source, destination) {
  return { ...source, ...destination };
}

function I18n(locale) {
  if(localeSupported(locale)) {
    return getLocale(locale);
  }
  else {
    return getLocale(defaultLocale);
  }
}

export default I18n;